import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '~/components/ui/icon';
import Menu from '~/components/ui/Menu';

import { StyledWrapper } from './styled';

const LANGUAGE_ICONS = {
  en: 'UnitedKingdom',
  es: 'Spain',
};

export default function LanguageSelector() {
  const { i18n } = useTranslation();

  const [open, setOpen] = useState(false);

  const selectorRef = useRef(null);

  const getLanguage = () => {
    return localStorage.getItem('language') || 'en';
  };

  const [language, setLanguage] = useState(getLanguage());

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleChangeLanguage = (language) => {
    setLanguage(language);
    localStorage.setItem('language', language);
    i18n.changeLanguage(language);
    handleClose();
  };

  const arrowIcon = open ? 'ArrowUp' : 'ArrowDown';

  return (
    <>
      <StyledWrapper ref={selectorRef} onClick={handleOpen}>
        <Icon size={24} withParentColor={false} icon={LANGUAGE_ICONS[language]} />
        <Icon size={20} withParentColor={false} icon={arrowIcon} />
      </StyledWrapper>
      <Menu
        open={open}
        handleClose={handleClose}
        onSelect={handleChangeLanguage}
        anchorEl={selectorRef.current}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        selectedValue={language}
        items={[
          { label: 'English', icon: 'UnitedKingdom', value: 'en' },
          { label: 'Spanish', icon: 'Spain', value: 'es' },
        ]}
      />
    </>
  );
}
